import React, { useCallback, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import whitepaperPdf from "../../../assets/ZillionWhitePaper.pdf";
import "./whitepaper.css";

const PDFJS_CDN = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
const PDFJS_WORKER = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";

const loadPdfJs = () => {
  if (window.pdfjsLib) {
    return Promise.resolve(window.pdfjsLib);
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = PDFJS_CDN;
    script.async = true;
    script.onload = () => {
      window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER;
      resolve(window.pdfjsLib);
    };
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

const Whitepaper = () => {
  const containerRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const renderPdf = useCallback(async () => {
    if (!containerRef.current) return;

    try {
      setLoading(true);
      setError("");

      const pdfjsLib = await loadPdfJs();
      const pdf = await pdfjsLib.getDocument(whitepaperPdf).promise;

      containerRef.current.innerHTML = "";

      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum += 1) {
        const page = await pdf.getPage(pageNum);
        const viewport = page.getViewport({ scale: 1.4 });
        const canvas = document.createElement("canvas");
        canvas.className = "whitepaper-page";
        canvas.setAttribute("draggable", "false");

        const context = canvas.getContext("2d");
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        containerRef.current.appendChild(canvas);
        await page.render({ canvasContext: context, viewport }).promise;
      }
    } catch (err) {
      console.error("Whitepaper load failed:", err);
      setError("Unable to load whitepaper. Please try again later.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    renderPdf();
  }, [renderPdf]);

  useEffect(() => {
    const blockKeys = (event) => {
      if ((event.ctrlKey || event.metaKey) && ["s", "p", "u", "S", "P", "U"].includes(event.key)) {
        event.preventDefault();
      }
    };

    const blockDefault = (event) => event.preventDefault();

    document.addEventListener("keydown", blockKeys);
    document.addEventListener("contextmenu", blockDefault);
    document.addEventListener("dragstart", blockDefault);
    document.addEventListener("copy", blockDefault);

    return () => {
      document.removeEventListener("keydown", blockKeys);
      document.removeEventListener("contextmenu", blockDefault);
      document.removeEventListener("dragstart", blockDefault);
      document.removeEventListener("copy", blockDefault);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Zillion Whitepaper</title>
        <link rel="icon" type="image/svg+xml" href="/images/favicon_light.svg" />
        <meta name="robots" content="noindex" />
      </Helmet>

      <div
        className="whitepaper-viewer"
        onContextMenu={(event) => event.preventDefault()}
        onCopy={(event) => event.preventDefault()}
        onDragStart={(event) => event.preventDefault()}
      >
        <header className="whitepaper-viewer__header">
          <img src="/New_logo.svg" alt="Zillion Exchange" className="whitepaper-viewer__logo dark_img" />
          <img src="/New_logo.svg" alt="Zillion Exchange" className="whitepaper-viewer__logo light_img" />
          <h1>Zillion Whitepaper</h1>
          <p>Read-only view</p>
        </header>

        {loading && <div className="whitepaper-viewer__loading">Loading whitepaper...</div>}
        {error && <div className="whitepaper-viewer__error">{error}</div>}

        <div ref={containerRef} className="whitepaper-viewer__pages" />
      </div>
    </>
  );
};

export default Whitepaper;
